export default __webpack_public_path__ + "locales/si/DeleteProfileEverDialog.json?hash=452aaf3747e97ecaedc74e52ba4d0aec";